module.exports = {
  NODE_ENV: 'development',
  requestUrl: 'http://192.168.1.213:8082'
}